import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { format } from "date-fns";
// import Table from "core/pagination/datatable";
import TableTop from "Components/UI/TableTop";
import { useTableSearch } from "core/Operations/useTableSearch";
import { Edit, PlusCircle } from "feather-icons-react/build/IconComponents";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useGeneratePayrollQuery } from "AppQuries/payroll/generate-payroll";
import Error404 from "MainPages/ErrorPages/error404";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { Alert, Spin, Input, Table, Select, DatePicker } from "antd";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import styles from "../Payroll/GeneratePayroll.module.css";
import ReportTools from "Components/UI/ReportTools";
import {
  useFormattedDepartmentOption,
  useFormattedEmployees,
} from "core/Operations/formattedOption/useFormattedEmployeeOptions";
const { RangePicker } = DatePicker;
import dayjs from "dayjs";
import { endOfMonth, startOfMonth } from "date-fns";
import { useGetForeCastReportQuery } from "AppQuries/report/get-forecast-report";
import { all_routes } from "Router/all_routes";
import { BackIcon } from "Components/UI/Icon/Icons";
const salaryTypeOptions = [
  {
    id: "01",
    text: "Monthly",
    value: "Monthly",
  },
  // {
  //   id: "02",
  //   text: "Daily",
  //   value: "Daily",
  // },
  {
    id: "03",
    text: "Hourly",
    value: "Hourly",
  },
];
const ForecastReport = () => {
  const userData = useSelector(loggedInUser);

  const [queryParams, setQueryParams] = useState({
    fromDate: format(startOfMonth(new Date()), "yyyy-MM-dd"),
    toDate: format(endOfMonth(new Date()), "yyyy-MM-dd"), //format(new new Date(), "yyyy-MM-dd"),
    employeeCode: 0,
    departmentCode: "",
    salaryType: "",
  });

  const employeeOptions = useFormattedEmployees({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    departmentCode: 0,
  });

  const daprtmentOptions = useFormattedDepartmentOption(userData?.companyCode);

  const {
    data: reportData,
    isFetching: generatingPayroll,
    isError: isGeneratePayrollError,
    error: generatePayrollError,
    refetch: getReport,
  } = useGetForeCastReportQuery(
    {
      companyCode: userData?.companyCode,
      locationCode: userData?.selectedLocationCode,
      userId: userData?.userID,
      isAllCompanies: userData?.isAllCompanies,
      selectedCompanyCode: userData?.selectedCompanyCode,
      ...queryParams,
    },
    {
      enabled: false,
    }
  );

  const columns = [
    {
      title: "Emp Code",
      dataIndex: "uniqueID",
      sorter: (a, b) => a.uniqueID - b.uniqueID,
    },
    {
      title: "Emp Name",
      dataIndex: "fullName",
      key: "fullName",
      fixed: "left",
      render: (text) => (
        <p className="table-avatar" style={{ width: "150px" }}>
          {text}
        </p>
      ),
    },
    {
      title: "Basic Pay",
      dataIndex: "basicSalary",
      key: "basicSalary",
    },
    {
      // title: "No.of Days in Month",
      title: "No.of Working Days",
      dataIndex: "noOfDaysInMonth",
      key: "noOfDaysInMonth",
    },
    {
      title: "No.of Worked Days / Hours",
      dataIndex: "payrollValue",
      key: "payrollValue",
    },
    {
      title: "OT Pay (Day)",
      dataIndex: "noOfOTWorkingDaysSalary",
      key: "noOfOTWorkingDaysSalary",
    },
    {
      title: "OT Pay (Hour)",
      dataIndex: "otHourlySalary",
      key: "otHourlySalary",
    },
    // {
    //   title: "Leave Amount",
    //   dataIndex: "leaveAmount",
    //   key: "leaveAmount",
    //   render: (text, record, index) => (
    //     <Input
    //       {...register(`payrollData[${index}].leaveAmount`)}
    //       value={Number(text).toFixed(2)}
    //       className="form-control payroll-input"
    //       readOnly
    //       style={{ width: "100px" }}
    //     />
    //   ),
    // },
    {
      title: "Monthly Salary",
      dataIndex: "monthlySalary",
      key: "monthlySalary",
    },
    {
      title: "Deduction Hours ($)",
      dataIndex: "extraorlessHourAmt",
      key: "extraorlessHourAmt",
    },
    {
      title: "Leave Taken Days",
      dataIndex: "leaveTakenInDays",
      key: "leaveTakenInDays",
    },
    {
      title: "Leave Salary Amount ($)",
      dataIndex: "leaveAmount",
      key: "leaveAmount",
    },
    {
      title: "Allowances",
      dataIndex: "addition",
      key: "addition",
    },
    {
      title: "Gross Salary",
      dataIndex: "grossSalary",
      key: "grossSalary",
    },
    {
      title: "Deductions",
      dataIndex: "deduction",
      key: "deduction",
    },
    {
      title: "Emp CPF",
      dataIndex: "employeePercentage",
      key: "employeePercentage",
    },
    {
      title: "Employer CPF",
      dataIndex: "employerPercentage",
      key: "employerPercentage",
    },
    {
      title: "Fund",
      dataIndex: "agencyAmount",
      key: "agencyAmount",
    },
    {
      title: "SDL",
      dataIndex: "sdlAmount",
      key: "sdlAmount",
    },
    {
      title: "Net Pay",
      dataIndex: "netPay",
      key: "netPay",
    },
  ];

  const updateQueryParams = (key, value) => {
    setQueryParams((prev) => ({ ...prev, [key]: value }));
  };
  const [selectedRange, setSelectedRange] = useState([]);

  const disabledDate = (current) => {
    if (!selectedRange || selectedRange.length === 0) return false;

    const firstDate = selectedRange[0];
    return !current.isSame(firstDate, "month");
  };

  if (isGeneratePayrollError) return <Error404 error={generatePayrollError} />;

  if (generatingPayroll) return <LoadingSpinner />;

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Forecast Report</h4>
              <h6>Generate employees forecasting Payroll</h6>
            </div>
          </div>
          <ReportTools
            columns={columns}
            data={reportData}
            fileName={`Forecast Report (${queryParams.fromDate} - ${queryParams.toDate})`}
            pdfTheme="striped"
            refresh={getReport}
            isPdf={false}
          />
          <div className="page-btn">
            <Link
              to={`${all_routes.report_list}`}
              f
              className="btn btn-secondary"
            >
              <BackIcon className="me-2" />
              Back
            </Link>
          </div>
        </div>

        <div className="card border-0">
          <div className="card-body table-list-card">
            <div className="form-row row">
              <div className="col-lg-3 col-sm-6 col-12 mb-3">
                <div className="form-floating">
                  <RangePicker
                    className="form-control"
                    style={{ display: "flex" }}
                    // onChange={(date, dateFormat) => {
                    //   if (date) {
                    //     updateQueryParams("fromDate", dateFormat[0]);
                    //     updateQueryParams("toDate", dateFormat[1]);
                    //   }
                    // }}
                    onCalendarChange={(dates) => {
                      setSelectedRange(dates);
                    }}
                    onChange={(dates, dateStrings) => {
                      if (dates) {
                        updateQueryParams("fromDate", dateStrings[0]);
                        updateQueryParams("toDate", dateStrings[1]);
                      } else {
                        setSelectedRange([]);
                      }
                    }}
                    defaultValue={[
                      dayjs(queryParams.fromDate, "YYYY-MM-DD"),
                      dayjs(queryParams.toDate, "YYYY-MM-DD"),
                    ]}
                    dateFormat="YYYY-MM-DD"
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    disabledDate={disabledDate}
                  />
                  <label className="form-label">Start Date – End Date</label>
                </div>
              </div>
              <div className="col-lg-2 col-sm-6 col-12 mb-3">
                <div className="form-floating">
                  <Select
                    value={
                      queryParams?.salaryType ? queryParams?.salaryType : ""
                    }
                    options={salaryTypeOptions}
                    allowClear={true}
                    onSelect={(selectedOption) => {
                      updateQueryParams("salaryType", selectedOption);
                    }}
                    onClear={() => {
                      updateQueryParams("salaryType", 0);
                    }}
                    className="form-control"
                    variant="borderless"
                    showSearch={true}
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                  <label className="form-label">Salary Type</label>
                </div>
              </div>

              <div className="col-lg-2 col-sm-6 col-12 mb-3">
                <div className="form-floating">
                  <Select
                    value={
                      queryParams?.departmentCode
                        ? queryParams?.departmentCode
                        : ""
                    }
                    options={daprtmentOptions}
                    allowClear={true}
                    onSelect={(selectedOption) => {
                      updateQueryParams("departmentCode", selectedOption);
                    }}
                    onClear={() => {
                      updateQueryParams("departmentCode", 0);
                    }}
                    className="form-control"
                    variant="borderless"
                    showSearch={true}
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                  <label className="form-label">Department</label>
                </div>
              </div>

              <div className="col-lg-2 col-sm-6 col-12 mb-3">
                <div className="form-floating">
                  <Select
                    value={
                      queryParams?.employeeCode ? queryParams?.employeeCode : ""
                    }
                    options={employeeOptions}
                    allowClear={true}
                    onSelect={(selectedOption) => {
                      updateQueryParams("employeeCode", selectedOption);
                    }}
                    onClear={() => {
                      updateQueryParams("employeeCode", 0);
                    }}
                    className="form-control"
                    variant="borderless"
                    showSearch={true}
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                  <label className="form-label">Employee</label>
                </div>
              </div>

              <div className="col-lg-2 col-sm-6 col-12">
                <div className="input-blocks">
                  {/* <label className="form-label">&nbsp;</label> */}
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">Generate Report</Tooltip>
                    }
                  >
                    <button
                      className="btn btn-secondary"
                      type="button"
                      onClick={getReport}
                      // disabled={payrollMonth === 0 || payrollYear === 0}
                    >
                      Filter
                    </button>
                  </OverlayTrigger>
                </div>
              </div>
            </div>

            <div className="row">
              <div
                className={`table-responsive ${styles["table-responsive-2"]}`}
              >
                <Table
                  columns={columns}
                  dataSource={reportData}
                  rowKey={(record, index) => index}
                  pagination={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ForecastReport;
